import { tick } from "@angular/core/testing";

export class ServiceTruckOption {
  truckId: number;
  identifier: string;

  constructor(option: any) {
    this.truckId = option.truckId;
    this.identifier = option.identifier;
  }
}

export class TruckGroup {
  id: number;
  name: string;
  trucks = new Array<number>();

  constructor(truckGroup: any) {
    this.id = truckGroup.id;
    this.name = truckGroup.name;
    if (truckGroup.trucks != null) {
      truckGroup.trucks.forEach(element => {
        this.trucks.push(element);
      });
    }
  }
}

export enum MovementOrderProcessingStatus {
  OPEN = 'OPEN',
  STARTED = 'STARTED',
  MOVEMENT_STARTED = 'MOVEMENT_STARTED',
  MOVEMENT_COMPLETED = 'MOVEMENT_COMPLETED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED'
}

export enum MovementOrderVehicleStrategy {
  FIXED = 'FIXED', CHOOSE_AVAILABLE_SWAP_TRAILER = 'CHOOSE_AVAILABLE_SWAP_TRAILER', CHOOSE_AVAILABLE_TRAILER = 'CHOOSE_AVAILABLE_TRAILER'
}

export enum MovementOrderTargetStationStrategy {
  FIXED = 'FIXED', STATION_SET = 'STATION_SET'
}

export enum MovementOrderMovingStrategy {
  CLEAR_GATE = 'CLEAR_GATE', LESS_MOVEMENT = 'LESS_MOVEMENT'
}


export class CMovementOrderTableRow {
  id: number;
  priority: boolean;
  referenceDate: Date;
  scope: string;
  identifier: string;
  transportReference: string;
  processingStatus: MovementOrderProcessingStatus;
  currentStation: string;
  targetStation: string;
  movementStrategy: MovementOrderMovingStrategy;

  constructor(movementOrder: any) {
    this.id = movementOrder.id;
    this.priority = movementOrder.priority;
    this.referenceDate = movementOrder.referenceDate;
    this.scope = movementOrder.scope;
    this.identifier = movementOrder.identifier;
    this.transportReference = movementOrder.transportReference;
    this.processingStatus = movementOrder.processingStatus;
    this.currentStation = movementOrder.currentStation;
    this.targetStation = movementOrder.targetStation;
    this.movementStrategy = movementOrder.movementStrategy;
  }
}

export class MovementOrderDetails {
  id: number;
  priority: boolean;
  referenceDate: Date;
  scope: string;
  identifier: string;
  transportReference: string;
  processingStatus: MovementOrderProcessingStatus;
  currentStation: string;
  targetStation: string;
  targetStationSetId: number;
  vehicleStrategy: MovementOrderVehicleStrategy;
  targetStationStrategy: MovementOrderTargetStationStrategy;
  reroutingNeeded: boolean;

  constructor(movementOrder: any) {
    this.id = movementOrder.id;
    this.priority = movementOrder.priority;
    this.referenceDate = movementOrder.referenceDate;
    this.scope = movementOrder.scope;
    this.identifier = movementOrder.identifier;
    this.transportReference = movementOrder.transportReference;
    this.processingStatus = movementOrder.processingStatus;
    this.currentStation = movementOrder.currentStation;
    this.targetStation = movementOrder.targetStation;
    this.targetStationSetId = movementOrder.targetStationSetId;
    this.vehicleStrategy = movementOrder.vehicleStrategy;
    this.targetStationStrategy = movementOrder.targetStationStrategy;
    this.reroutingNeeded = movementOrder.reroutingNeeded;
  }
}

export interface MovementOrderStrategy {
  targetStationId: number
  vehicleId: number;
}

export interface MovementOrderSelection {
  serviceTruckId: number;
  truckGroupId: number;
}

export interface ProcessingStatusChange {
  movementOrderId: number;
  processingStatus: MovementOrderProcessingStatus;
  serviceTruckId: number;
  vehicleId: number;
  targetStationId: number;
  reroutingTargetStationId: number
}

export class Vehicle {
  id: number;
  carrier: string;
  identifier: string;
  driverName: string;
  currentStation: string;
  scope: string;

  constructor(vehicle?: any) {
    if (vehicle != null) {
      this.id = vehicle.id;
      this.carrier = vehicle.carrier;
      this.identifier = vehicle.identifier;
      this.driverName = vehicle.driverName;
      this.currentStation = vehicle.currentStation;
      this.scope = vehicle.scope;
    }
  }
}

export interface VehicleSelection {
  vehicleStrategy: MovementOrderVehicleStrategy;
}

export interface CancelMovingOrder {
  movementOrderId: number;
}

